import { Paper, Box, Typography, keyframes } from "@mui/material";

const scaleIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const AlertStatsCard = ({ label, value, icon: Icon, bgColor, iconColor, delay = 0 }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        flex: 1,
        p: 2.5,
        borderRadius: 3,
        bgcolor: "#fff",
        display: "flex",
        alignItems: "center",
        gap: 2,
        cursor: "pointer",
        animation: `${scaleIn} 0.4s ease-out ${delay}s both`,
        transition: "all 0.2s ease",
        border: "1px solid #E2E8F0",
        borderLeft: `4px solid ${iconColor}`,
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
        },
      }}
    >
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: 3,
          bgcolor: bgColor,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "transform 0.2s ease",
        }}
      >
        <Icon sx={{ fontSize: 26, color: iconColor }} />
      </Box>
      <Box>
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: 700,
            color: "#94A3B8",
            fontStyle: "bold",
            textTransform: "uppercase",
            letterSpacing: 0.5,
            mb: 0.5,
          }}
        >
          {label}
        </Typography>
        <Typography
          sx={{
            fontSize: 30,
            fontWeight: 700,
            color: "#1E293B",
            lineHeight: 1,
          }}
        >
          {value}
        </Typography>
      </Box>
    </Paper>
  );
};

export default AlertStatsCard;
